<template>
  <div id="app" class="page-container">
    <div class="header" ref="imageContainer">
      <img class="logo" alt="Logo" src="./assets/logo_tech.png" />
    </div>
    <NavBar />
    <div class="content">
      <router-view />
    </div>
    <div class="footer">
      <a href>
        <img src="./assets/js.svg" class="stack" />
      </a>
      <a>
        <img src="./assets/css3-1.svg" class="stack" />
      </a>
      <a>
        <img src="./assets/firebase.svg" class="stack" />
      </a>
      <a>
        <img src="./assets/vs.svg" class="stack" />
      </a>
      <a>
        <img src="./assets/nodejs.svg" class="stack" />
      </a>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, provide } from "vue";
import * as firebaseui from "firebaseui";
import { auth } from "./firebaseConfig"; // Use the shared auth instance
import NavBar from "./components/NavBar.vue"; // Import NavBar component

export default {
  name: "App",
  components: { NavBar },
  setup() {
    const imageContainer = ref(null);

    // Create a promise to resolve when ui is initialized
    let uiResolve;
    const uiPromise = new Promise((resolve) => {
      uiResolve = resolve;
    });
    provide("firebaseUIPromise", uiPromise);

    // Create the ui instance as a computed ref
    const ui = computed(() => {
      const uiInstance = new firebaseui.auth.AuthUI(auth);
      uiResolve(uiInstance); // Resolve the promise when ui is created
      return uiInstance;
    });
    provide("firebaseUI", ui);

    onMounted(() => {
      // Trigger the evaluation of the computed property
      const uiInstance = ui.value; // Access ui.value to trigger evaluation
      console.log(uiInstance ? "" : "UI Not Ready"); // You should see the uiInstance logged
    });

    return {
      imageContainer,
    };
  },
};
</script>

<style lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  font-family: 'Inter', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

.stack {
  margin: 40px 15px 15px 15px;
  width: 40px;
  height: 40px;
  opacity: 0.5;
  transition: all 0.3s ease;
  filter: grayscale(100%);
}

.stack:hover {
  transform: translateY(-5px);
  opacity: 1;
  filter: grayscale(0%);
}

.header {
  align-items: center;
  padding: 20px 0;
}

.logo {
  max-width: 100%;
  width: 280px;
  margin: 0 auto;
  mix-blend-mode: screen; /* Makes the black background completely transparent! */
}

.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}

.page-container {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
}

@media (max-width: 800px) {
  .page-container {
    padding: 0 10px;
  }
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  height: 100%;
  background: #0f172a radial-gradient(circle at top, #1e293b 0%, #0f172a 100%);
  background-attachment: fixed;
  color: $text-color;
}
</style>